import React from 'react'
import item from './FreePlanDetails.json'
import styles from './pricingCardsStyle.module.scss'

class Free extends React.Component {
  static defaultProps = {
    data: item.item,
    type: '',
    extended: false,
  }

  render() {
    const { data, extended, type } = this.props

    return (
      <div
        className={`${styles.item}  ${extended ? styles.extended : ''} ${type ? styles[type] : ''}`}
      >
        <div className={styles.header}>
          <div className={styles.price}>
            <span className={styles.currency}>{data.currency}</span>
            <span className={styles.amount}>{data.amount}</span>
            <span className={styles.period}>{data.period}</span>
          </div>
          <div className={styles.title}>{data.title}</div>
        </div>
        <ul className={styles.features}>
          {data.features.map(feature => (
            <li key={feature.id}>
              <strong>{feature.main}</strong> {feature.description}
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

export default Free
